var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoRecordedSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5H6.05946L7.55946 6.5H5C4.17157 6.5 3.5 7.17157 3.5 8V16C3.5 16.8284 4.17157 17.5 5 17.5H14C14.8284 17.5 15.5 16.8284 15.5 16V14.4405L17 15.9405V16C17 17.6569 15.6569 19 14 19H5C3.34315 19 2 17.6569 2 16V8C2 6.34315 3.34315 5 5 5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8V12.3192L17 13.8192V10.7386L19.6951 8.66541C20.024 8.41248 20.5 8.64689 20.5 9.06173V16.8758C21.3244 16.659 22 15.9267 22 14.9383V9.06173C22 7.40238 20.0958 6.46476 18.7806 7.47648L17 8.84615V8C17 6.34315 15.6569 5 14 5H8.18078L9.68078 6.5H14C14.8284 6.5 15.5 7.17157 15.5 8Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46967 2.46967C2.76256 2.17678 3.23744 2.17678 3.53033 2.46967L21.5303 20.4697C21.8232 20.7626 21.8232 21.2374 21.5303 21.5303C21.2374 21.8232 20.7626 21.8232 20.4697 21.5303L2.46967 3.53033C2.17678 3.23744 2.17678 2.76256 2.46967 2.46967Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecordedSession);
export default __webpack_public_path__ + "static/media/no-recorded-session.ec0f54812f0014c8a1767cad03e408fa.svg";
export { ForwardRef as ReactComponent };